import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ViaCheckApiQueryService} from './via-check-api-query.service';
import {CreateArchivosDTOextract} from '../models/dbdtos.interface';
import {StorageUserResponse} from '../models/dbresponses.interface';

@Injectable({
  providedIn: 'root',
})
export class FileUploadService extends ViaCheckApiQueryService {
  requiredFileType!: string;

  public uploadFile(
    file: File,
    uploadBody: CreateArchivosDTOextract
  ): Observable<any> {
    // leave this as Observable<any> unless you wanna suffer
    const subdomain = 'storage';

    const formData = new FormData();
    formData.append('file', file);
    if (uploadBody.tipo_archivo)
      formData.append('tipo_archivo', uploadBody.tipo_archivo);
    if (uploadBody.tipo_evidencia)
      formData.append('tipo_evidencia', uploadBody.tipo_evidencia);
    if (uploadBody.id_proyecto)
      formData.append('proyecto', `${uploadBody.id_proyecto}`);
    if (uploadBody.id_atributo)
      formData.append('atributo', `${uploadBody.id_atributo}`);
    if (uploadBody.id_registro)
      formData.append('registro', `${uploadBody.id_registro}`);
    return this.networkRequest('upload', subdomain, formData);
  }

  public getUserStuff(userId: number): Observable<StorageUserResponse> {
    const subdomain = `storage/user/${userId}`;
    return this.networkRequest('get', subdomain);
  }

  public deleteFile(url: string): Observable<any> {
    const subdomain = `storage/${url}`;
    return this.networkRequest('delete', subdomain);
  }
}
